<template>
  <v-text-field :modelValue="modelValue" :type="show ? 'text' : 'password'" class="pt-2"
    :append-inner-icon="show ? 'mdi-eye' : 'mdi-eye-off'" @click:append-inner="toggleShow"
    @change="action" :label="label" variant="outlined" density="compact"
    @update:modelValue="(newValue: string) => $emit('update:modelValue', newValue)" />
    
</template>
<script lang="ts">
import { Options, Vue } from 'vue-class-component'
@Options({
  props: {
    label: {
      type: String,
      default: ''
    },
    modelValue: {
      type: String,
      default: ''
    },
    action: {
      type: Function,
      default: () => {}
    }
  },
  emits: ['update:modelValue']
})
export default class SecretInput extends Vue {
  public label!: string
  public modelValue!: string
  public action!: Function
  public show: boolean = false

  public toggleShow() {
    this.show = !this.show
  }
}
</script>
<style scoped lang="scss">
</style>